var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D6DFF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0695 37C26.7297 37 28.1184 35.8165 28.4373 34.25H21.7017C22.0207 35.8165 23.4095 37 25.0695 37Z",
    fill: "#1E4793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4971 25.9991C31.4934 25.9991 31.4897 26 31.486 26C27.9486 26 25.0694 23.1216 25.0694 19.5834C25.0694 18.6107 25.2931 17.6912 25.6827 16.8644C25.481 16.8453 25.2765 16.8334 25.0694 16.8334C21.5257 16.8334 18.6528 19.7061 18.6528 23.25V25.8056C18.6528 27.6197 17.858 29.3321 16.4637 30.5109C15.999 30.9078 15.7927 31.5403 15.9595 32.1573C16.1539 32.875 16.8634 33.3334 17.6078 33.3334H32.5265C33.3075 33.3334 34.0437 32.8273 34.2021 32.0619C34.325 31.4698 34.1142 30.8784 33.6549 30.4926C32.3221 29.3752 31.5511 27.7333 31.4971 25.9991Z",
    fill: "#1E4793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0694 19.5834C36.0694 22.1147 34.0175 24.1666 31.4861 24.1666C28.9548 24.1666 26.9028 22.1147 26.9028 19.5834C26.9028 17.0521 28.9548 15 31.4861 15C34.0175 15 36.0694 17.0521 36.0694 19.5834Z",
    fill: "#E03232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.1dfdb0bf192404ce080398b9ad529758.svg";
export { ForwardRef as ReactComponent };